module.exports = __webpack_public_path__ + "img/HeaderLayoutR.2ca1f0ce.jpg";